export const CORE_ROUTES = {
  employeeHome: "/employee",
  employeeLogin: "/employee/user/login",
  employeeForgotPassword: "/employee/user/forgot-password",
  employeeChangePassword: "/employee/user/change-password",
  employeeProfile: "/employee/profile",
  employeeProfileChangePassword: "/employee/profile/change-password",
} as const;
